import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { getIconColour } from '../../../../helpers/app';
import CrmSection from './CrmSection';
import WallpaperIcon from '../../../../assets/icons/Wallpaper';
import { AppInfo } from './common';
import { DSTheme } from '../../../../styles/themes/types';
import { descriptionAndPreviewState } from './helper';
import { ApplicationInterface } from '../../../../interfaces/application';

type PropsType = {
  application: ApplicationInterface;
};

const useStyles = makeStyles((theme: DSTheme) => ({
  container: {
    display: 'grid',
    gridRowGap: '47px',
  },
  image: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    backgroundColor: theme.palette.background.elevation2,
    borderRadius: '16px',
    marginTop: '18px',
    width: '152px',
    height: '152px',

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
}));

const CrmDescriptionAndPreview: React.FC<PropsType> = ({ application }) => {
  const type = descriptionAndPreviewState(application);
  const classes = useStyles();
  const theme = useTheme();

  return (
    <CrmSection
      icon={<WallpaperIcon stroke={getIconColour(type, theme)} />}
      title="Description & Previews"
      description="Descriptions and preview images for end-user Connections Library. "
      type={type}
    >
      <div className={classes.container}>
        <AppInfo label="Short Description" value={application.info.shortDescription} />
        <AppInfo label="Long Description" value={application.info.description} />
        <AppInfo label="Application Purpose" value={application.info.dataUsePurpose} />

        <div>
          <label htmlFor="ds-profile-icon">
            <Typography variant="body2">Application Icon</Typography>
          </label>

          <div className={classes.image}>
            <img src={application.assets?.appLogoUrl?.contentUrl} alt="Application Logo" />
          </div>
        </div>
      </div>
    </CrmSection>
  );
};

export default CrmDescriptionAndPreview;
